var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 191 156",
    "aria-labelledby": "twitterIcon twitterDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.7 18.5c-7.1 3.1-14.7 5.2-22.5 6.2 8.2-4.9 14.3-12.7 17.2-21.8-7.7 4.6-16.1 7.8-24.8 9.5-12.2-13-31.5-16.1-47.1-7.8C97.9 13 89.9 30.8 94 48.1 62.5 46.5 33.2 31.7 13.3 7.2 2.9 25.1 8.2 48 25.4 59.5c-6.2-.2-12.3-1.9-17.7-4.9-.2 18.8 12.9 35.2 31.4 38.9-3.3.9-6.8 1.3-10.3 1.3-2.5 0-4.9-.2-7.4-.7 5.1 15.9 19.8 26.8 36.5 27.1C44.1 132.1 27 138 9.4 138c-3.2.2-6.3.2-9.4 0 17.9 11.5 38.8 17.6 60.1 17.6 29.5.2 58-11.5 78.9-32.4 20.9-20.9 32.6-49.4 32.4-78.9v-5.1c7.6-5.7 14.2-12.7 19.3-20.7z"
  })));
}

export default SvgIconSocialTwitter;